import { COLORS } from "@/lib/theme";

const links = [
  ["www.linkshul.co.za", "https://www.linkshul.co.za"],
  ["011 640 5812", "tel:+27116405812"],
  ["admin@linkshul.co.za", "mailto:admin@linkshul.co.za"],
  ["office@linkshul.co.za", "mailto:office@linkshul.co.za"],
  ["operations@linkshul.co.za", "mailto:operations@linkshul.co.za"],
  ["leviavtzon@gmail.com", "mailto:leviavtzon@gmail.com"],
];

export default function LoginContactFooter({ light = false }) {
  const color = light ? "rgba(255,255,255,.9)" : COLORS.muted;
  return (
    <div data-testid="login-contact-footer" style={{ marginTop: 22, paddingTop: 16, borderTop: `1px solid ${light ? "rgba(255,255,255,.2)" : COLORS.border}`, textAlign: "center", fontSize: 12.5, fontWeight: 700, lineHeight: 1.8 }}>
      <div style={{ color, fontWeight: 800, marginBottom: 3 }}>LinkShul information</div>
      {links.map(([label, href]) => (
        <div key={href}><a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" style={{ color: light ? "#fff" : COLORS.purple, textDecoration: "none" }}>{label}</a></div>
      ))}
    </div>
  );
}
